// placing this outside the component in case it's needed elsewhere
// eslint-disable-next-line import/prefer-default-export
export const IMPORTANT_SERVICE_CODES = [
  'ERS247',
  'ProMRT',
  'ProXone',
  'MichNatAcc',
  'FIXPIX',
];



// WEBPACK FOOTER //
// ./src/components/ServiceSummaryIcons/constants.js